import { EntitySortableField, SortDir } from 'core/graphql';
import { SortOptionType } from 'shared/components/internal/SortMenu';

export const sortOptions: SortOptionType<EntitySortableField> = {
  activityScore: {
    label: 'Activity Score',
    name: EntitySortableField.ActivityScore,
  },
  name: {
    label: 'Name',
    name: EntitySortableField.Name,
  },
  recentSignalSeverity: {
    defaultDirection: SortDir.Desc,
    label: 'Signal Severity Total',
    name: EntitySortableField.RecentSignalSeverity,
  },
  type: {
    label: 'Type',
    name: EntitySortableField.Type,
  },
};

export const DEFAULT_SORT = 'activityScore';
export const DEFAULT_SORT_DIR: SortDir = SortDir.Desc;
